module.exports = __webpack_public_path__ + "static/media/BCS-2Views_2.541dc4ee.png";